import Base from "../Base";
import { CourseType } from "../../services/courseService";

class CourseApiClient extends Base {
  async list(courseType: CourseType, options: { organizationName?: string; } = {}) {
    return await this.get(`/courses/${courseType}`, {
      query: {
        org: options.organizationName
      }
    });
  }

  async book(type: CourseType, data: any) {
    return await this.post(`/course/book/${type}`, data);
  }

  async bookVKU(data: any) {
    return await this.post(`/course/book/vku`, data);
  }
}

export default new CourseApiClient();